<jni-bc-revenue-transactions
  [bcRevenueLists]="totalSalesCommissionsAdjustmentsList"
  [BCAvgMargin]="BCAvgMargin"
  [TotalBCCommission]="TotalBCCommission"
  [TotalBCGP]="TotalBCGP"
  [TotalBCReserve]="TotalBCReserve"
  [TotalBCRevenue]="TotalBCRevenue"
  (closeModalEvent)="onCloseModalEvent()"></jni-bc-revenue-transactions>
